import { Page } from '../../../core/entities/page/page';
import { gql } from 'apollo-angular';
import { Task } from 'src/app/rent-module/shared/entities/task/task';

export const TASK_LIST_QUERY = gql`
query TaskListQuery(
  $orderId: UUID,
  $states: [TaskState],
  $types: [String],
  $sortProperty: String,
  $sortDirection: String,
  $pageNumber: Int,
  $pageSize: Int
)
{
  tasks: getTasksPaged(
    taskFilter: {
      orderId: $orderId,
      states: $states,
      types: $types,
      sortRequest: {sortProperties: [$sortProperty], sortDirection: $sortDirection},
      pagination: { number: $pageNumber, size: $pageSize},
  }){
      totalPages
      totalElements
      number
      size
      content{
        id
        description
        dueDateTimePeriod{
          modifier
          dateTime
          fromDateTime
          toDateTime
          precision
        }
        completedBy {
          id
          firstName
          lastName
        }
        completedDateTime
        protocol{
          id
          type
          state
          completedDateTime
          completedBy {
            firstName
            lastName
          }
          formControlTemplate
          task{
            id
            completedBy{
              firstName
              lastName
            }
            assignment {
              assigneeId
              assignmentType
              typeLabel
              name
              dueDateTimePeriod{
                  modifier
                  dateTime
                  fromDateTime
                  toDateTime
              }
            }
          }
        }
      }
    }
}
`;

export interface TaskListQueryResponse {
  tasks: Page<Task>;
  loading: boolean;
}


